<template>
  <div @click="onClick">
    <div class="combo-card" :class="{ 'is-checked': checked }">
      <div class="combo-header">
        <div class="combo-index" :class="{ 'is-checked': checked }">
          方案{{ value.index }}
        </div>
        <div class="combo-title">
          <div>{{ value.comboName }}</div>
          <el-tooltip
            class="item"
            :content="`最高限价：￥${value.maxLimitPrice}`"
            placement="top"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </div>
      </div>

      <div class="combo-grid">
        <div class="combo-grid-row">
          <span>首付金额</span>
          <span>￥{{ value.prepayPrice }}</span>
        </div>
        <div class="combo-grid-row">
          <span>监管服务费</span>
          <span>￥{{ value.lockPrice }}</span>
        </div>
        <div class="combo-grid-row">
          <span>剩余租金</span>
          <span>￥{{ value.leftRentPrice }}（{{ value.leftBillNum }}期）</span>
        </div>
        <el-divider />
        <div
          v-for="(billItem, index) in value.leftBillList"
          :key="index"
          class="combo-grid-row"
        >
          <span>{{ billItem.billName }}</span>
          <span>￥{{ billItem.leftPayAmount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ComboGradeToColorMap } from "@/enum/dict/combo";

export default {
  name: "ComboCard",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return { ComboGradeToColorMap };
  },

  methods: {
    onClick() {
      this.$emit("checkedChange");
    },
  },
};
</script>

<style lang="scss" scoped>
.combo-card {
  border: 2px solid #e4e7ed;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  overflow: hidden;
  padding: 12px;
  color: #303133;
  transition: all 0.3s ease;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  
  &:hover {
    border-color: #409EFF;
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.2);
    transform: translateY(-2px);
  }
  
  &.is-checked {
    border-color: #409EFF !important;
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.3);
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.02) 0%, rgba(102, 177, 255, 0.02) 100%);
  }
}

.combo-header {
  display: flex;
  height: 50px;
  line-height: 50px;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;
  border-radius: 10px;
  gap: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.combo-index {
  display: flex;
  width: 22%;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 10px;
  font-weight: 600;
  color: #606266;
  transition: all 0.3s ease;
  
  &.is-checked {
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  }
}

.combo-title {
  display: flex;
  width: 78%;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #ffffff;
  border-radius: 10px;
  font-size: 14px;
  color: #303133;
  
  .el-icon-warning-outline {
    color: #f56c6c;
    font-size: 16px;
    cursor: help;
    
    &:hover {
      color: #f78989;
    }
  }
}

.combo-grid {
  display: flex;
  flex-direction: column;
  min-height: 320px;
  max-height: 400px;
  background-color: #ffffff;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 32px;
  padding: 8px 0;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
    
    &:hover {
      background: #a8abb2;
    }
  }

  .combo-grid-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: #f5f7fa;
    }
    
    span {
      &:first-child {
        color: #606266;
      }
      
      &:last-child {
        color: #303133;
        font-weight: 600;
      }
    }
  }

  .el-divider--horizontal {
    margin: 8px 0 !important;
    background-color: #e4e7ed;
  }
}
</style>
